import React, {FunctionComponent, useEffect} from 'react';

import {IMaintenanceRepair} from "../../../models/MaintenanceRepair/MaintenanceRepair";
import {arraySum, displayDate, displayDollarAmount} from "../../../lib/utilities";
import {observer} from "mobx-react-lite";
import Agent from "../../../api/Agent";
import {useAPIPager} from "../../../hooks/useAPIPager";
import {useSelectTable} from "../../../hooks/useSelectTable";
import Table from '../../table/Table';
import TR from '../../table/TR';
import THead from '../../table/THead';
import TBody from '../../table/TBody';
import TD from '../../table/TD';
import Pagination from "../../table/Pagination";
import Skeleton from "../../generic/Skeleton";
import Checkbox from "../../Inputs/Checkbox";

interface OwnProps {
    onChange?: (e: string[]) => (void)
    selected?: string[]
    predicates?: Map<any, any>
}

type Props = OwnProps;

const MaintenanceRepairSelectTable: FunctionComponent<Props> = ({onChange, selected, predicates}) => {
    // Custom Hooks
    const {items, count, handleChangePage, isLoading} = useAPIPager(Agent.MaintenanceRepair, predicates)
    const {handleCheckAll, handleCheck, selectedItems} = useSelectTable(selected);

    // Use Effects
    useEffect(() => {
        !!onChange && onChange(selectedItems)
    }, [selectedItems]);

    return (<>
        <span className="sr-only" id="maintenanceRepairSelectTable">Maintenance/Repair</span>
        <Table className={'max-w-full'} aria-describedby={'maintenanceRepairSelectTable'}>
            <THead>
                <TR>
                    <TD className={'th min-w-max whitespace-nowrap'}>
                        {items.length > 0 && <>
                            <span id="selectAllMaintenanceRepair" className="sr-only">Select all</span>
                            <Checkbox label={<span className={'sr-only'}>Select</span>}
                                checked={items.every(i => selectedItems?.includes(i.id))}
                                className="border-gray-300 rounded"
                                onChange={(e) => handleCheckAll(e, items)}/></>}
                    </TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Consumer</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Technician</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Date Performed</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Cost</TD>
                </TR>
            </THead>
            <TBody>
                {items?.map((maintenanceRepair: IMaintenanceRepair, idx) => {
                    return (<TR key={idx}>
                        {isLoading ? <TD colSpan={100}><Skeleton/></TD> : <>
                            <TD className={'td min-w-max whitespace-nowrap'}>
                                <Checkbox checked={selectedItems.includes(maintenanceRepair.id ?? '')}
                                       onChange={handleCheck} value={maintenanceRepair.id}
                                          label={<span className={'sr-only'}>Select</span>}
                                />
                            </TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{maintenanceRepair?.consumerName}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{maintenanceRepair?.technicianName}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDate(maintenanceRepair?.datePerformed)}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDollarAmount(arraySum([
                                maintenanceRepair.auxiliaryAidCosts,
                                maintenanceRepair.otherCosts,
                                maintenanceRepair.timeMaterialsCosts,
                            ]))}</TD>
                        </>}
                    </TR>)
                })}
            </TBody>
        </Table>
        <Pagination totalRows={count} onPageChange={handleChangePage} onRowChange={handleChangePage}/>
    </>);
};

export default observer(MaintenanceRepairSelectTable);
